import React from 'react';

interface ProDateRangeProps {
    bumpFalloffReport: InsightBumpFalloffReport;
    pro: Maybe<string>;
}

export const ProDateRange = ({
    bumpFalloffReport,
    pro,
}: ProDateRangeProps): JSX.Element => {
    const { newer_statement_period, older_statement_period } =
        bumpFalloffReport;

    const displayPro = pro ? `${pro} ` : '';

    if (
        !older_statement_period?.year ||
        !older_statement_period?.quarter ||
        !newer_statement_period?.year ||
        !newer_statement_period?.quarter
    ) {
        return <>{displayPro}</>;
    }

    return (
        <>
            {displayPro}
            <span className="font-bold">{`${older_statement_period.year} Q${older_statement_period.quarter}`}</span>
            &nbsp;vs.&nbsp;
            <span className="font-bold">{`${newer_statement_period.year} Q${newer_statement_period.quarter}`}</span>
        </>
    );
};
